import { render, staticRenderFns } from "./VShippingList.vue?vue&type=template&id=9dde2a7a"
import script from "./VShippingList.vue?vue&type=script&lang=ts"
export * from "./VShippingList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports